import { render } from "./ProductV3.vue?vue&type=template&id=481e5a22&scoped=true"
import script from "./ProductV3.vue?vue&type=script&lang=js"
export * from "./ProductV3.vue?vue&type=script&lang=js"

import "./ProductV3.vue?vue&type=style&index=0&id=481e5a22&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481e5a22"]])

export default __exports__